/**
 * Origens da lead (passo 1 dos assistentes, obrigatória). Espelho de
 * functions/lib/engine/lead-origin.ts (outro tsconfig) — as chaves têm de ser
 * as mesmas; o servidor decide o `utm.source` e o «Referido por» do Odoo.
 */
export interface LeadOriginOption {
  key: string
  label: string
  /** Pede um texto (vai para «Referido por» no Odoo). */
  ask?: string
}

export const LEAD_ORIGINS: readonly LeadOriginOption[] = [
  { key: "prospeto_ativo", label: "Prospeto Vendedor Ativo" },
  { key: "prospeto_passivo", label: "Prospeto Vendedor Passivo" },
  { key: "referencia_cliente", label: "Referência de Cliente", ask: "Nome do cliente que referenciou" },
  { key: "carteira_clientes", label: "Carteira de Clientes" },
  { key: "crosseling_ativo", label: "Crosseling Ativo" },
  { key: "crosseling_passivo", label: "Crosseling Passivo" },
  { key: "upsseling_ativo", label: "Upsseling Ativo" },
  { key: "upsseling_passivo", label: "Upsseling Passivo" },
  { key: "facebook", label: "Facebook" },
  { key: "website", label: "Website" },
  { key: "lead_empresa", label: "Lead empresa", ask: "Como chegou a lead" },
]

export interface LeadOriginValue {
  lead_origin: string | null
  lead_origin_detail: string
}

export function leadOriginOption(key: string | null | undefined): LeadOriginOption | null {
  return LEAD_ORIGINS.find((o) => o.key === key) ?? null
}

/** Escolhida, e com o texto quando a origem o pede. */
export function isLeadOriginComplete(v: LeadOriginValue): boolean {
  const o = leadOriginOption(v.lead_origin)
  return !!o && (!o.ask || v.lead_origin_detail.trim().length > 0)
}

/** Para o payload: o texto só quando a origem o pede. */
export function leadOriginPayload(v: LeadOriginValue): { lead_origin: string | null; lead_origin_detail: string | null } {
  const o = leadOriginOption(v.lead_origin)
  return { lead_origin: o?.key ?? null, lead_origin_detail: o?.ask ? v.lead_origin_detail.trim() || null : null }
}

/** Da proposta guardada (editar). */
export function leadOriginFromRow(p: Record<string, unknown>): LeadOriginValue {
  return {
    lead_origin: leadOriginOption(p.lead_origin as string)?.key ?? null,
    lead_origin_detail: typeof p.lead_origin_detail === "string" ? p.lead_origin_detail : "",
  }
}
